import { com, kotlin } from '@eidu/web'
import formsBaseUrl from './baseUrl'
import fetchAuthorized from '../authorization/fetchAuthorized'
import Page = com.eidu.sharedlib.form.definition.Page
import KtList = kotlin.collections.KtList
import decodeFormContentFromJson = com.eidu.sharedlib.form.decodeFormContentFromJson

type GetFormContentTextParameters = {
  formId: String
  formContentId: string
}

const getFormContent = async ({ formId, formContentId }: GetFormContentTextParameters): Promise<KtList<Page>> => {
  return fetchAuthorized(
    (authContext) =>
      `${formsBaseUrl}/organizations/${authContext.organizationId}/forms/${formId}/contents/${formContentId}`
  ).then(async (it) => {
    const response = await it.text()
    if (it.status === 200) return decodeFormContentFromJson(response)
    else throw Error(`Unexpected response code ${it.status} from getFormContentText endpoint`)
  })
}

export default getFormContent
